import { inject, Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { DataConsumptionState } from '@shared/models/paywall/data-consumption-state';
import { StorageSpace } from '@shared/models/paywall/storage-space.enum';

@Injectable()
export class DataConsumptionStateService {
  private readonly translocoService = inject(TranslocoService);

  getDataConsumptionStateConfig = (storageSpace: StorageSpace): DataConsumptionState => {
    switch (storageSpace) {
      case StorageSpace.AVAILABLE:
        return {
          icon: '@tui.cloud-upload',
          styles: {
            hintAppearance: null,
            progressClass: 'bg-background-brand-secondary',
            containerClass: 'bg-background-brand-primary shadow-background-brand-primary/20',
          },
          label: this.translocoService.translate('Espace utilisé'),
          title: (remainingStorage) =>
            this.translocoService.translate('Il vous reste {{remainingStorage}} de stockage', { remainingStorage }),
        };
      case StorageSpace.LOW:
        return {
          icon: '@tui.triangle-alert',
          styles: {
            hintAppearance: null,
            progressClass: 'bg-background-warning-secondary',
            containerClass: 'bg-background-warning-primary shadow-background-warning-primary/20',
          },
          label: this.translocoService.translate('Espace utilisé'),
          title: () => this.translocoService.translate("Vous arrivez bientôt à court d'espace !"),
        };
      case StorageSpace.FULL:
        return {
          icon: '@tui.triangle-alert',
          styles: {
            hintAppearance: 'negative',
            progressClass: 'bg-background-error-secondary',
            containerClass: 'bg-background-error-primary shadow-background-error-primary/20',
          },
          label: this.translocoService.translate('Espace saturé'),
          title: () => this.translocoService.translate('Espace de stockage saturé !'),
        };
      default:
        throw new Error('Unknown storage space type');
    }
  };
}
